<template>
  <div class="payroll-report">
    <div class="payroll-report__header">
      <a-select
        v-model:value="period"
        class="payroll-report__period"
        :options="options"
        :loading="periodsLoading"
        placeholder="Расчётный период" />

      <a-descriptions
        class="payroll-report__totals"
        size="small"
        bordered
        :column="2">
        <a-descriptions-item label="Планировок">
          {{ report?.total_plans_count ?? 0 }}
        </a-descriptions-item>
        <a-descriptions-item label="Итого BRP">
          <b>{{ formatAmount(report?.total_amount ?? 0) }}</b>
        </a-descriptions-item>
      </a-descriptions>
    </div>

    <a-spin :spinning="loading">
      <payroll-projects
        :projects="report?.projects ?? []"
        :editable="editable"
        @changed="loadReport" />
    </a-spin>
  </div>
</template>

<script setup>
import {
  computed, onMounted, ref, watch,
} from 'vue';
import { message } from 'ant-design-vue';
import { api } from '@/api';
import PayrollProjects from '@/Components/CRM/Payroll/PayrollProjects.vue';
import { formatAmount, periodOptions } from '@/Components/CRM/Payroll/payrollFormat';

const emit = defineEmits(['loaded']);

const props = defineProps({
  employeeId: {
    type: Number,
    default: null,
  },
  editable: {
    type: Boolean,
    default: false,
  },
});

const periods = ref([]);
const period = ref(null);
const periodsLoading = ref(false);
const loading = ref(false);
const report = ref(null);

const options = computed(() => periodOptions(periods.value));

const loadReport = async () => {
  if (!period.value) return;

  loading.value = true;

  try {
    const { data } = props.employeeId === null
      ? await api.getMyPayroll({ period: period.value })
      : await api.getEmployeePayroll(props.employeeId, { period: period.value });

    report.value = data;
    emit('loaded', data);
  } catch (e) {
    message.error(e.response?.data?.message ?? 'Не удалось загрузить начисления');
  } finally {
    loading.value = false;
  }
};

const loadPeriods = async () => {
  periodsLoading.value = true;

  try {
    const { data } = await api.getPayrollPeriods();
    periods.value = data.items;
    period.value = data.items.find((item) => item.key === data.current.key)?.key
      ?? data.items[0]?.key
      ?? null;
  } catch (e) {
    message.error(e.response?.data?.message ?? 'Не удалось загрузить расчётные периоды');
  } finally {
    periodsLoading.value = false;
  }
};

watch(period, loadReport);
watch(() => props.employeeId, loadReport);

onMounted(loadPeriods);
</script>

<style lang="scss" scoped>
.payroll-report {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
  }

  &__period {
    min-width: 240px;
  }

  &__totals {
    flex: 1 1 320px;
  }
}
</style>
